const getBaseUrl = () => {
  const [ret] = window.location.href.match(/^.*:\/\/[^/]+/);
  return ret;
};

export default getBaseUrl();
